import { useEffect, useRef, useState } from "react";

export default function ScrollReveal({ children, delay = 0, as: Tag = "div", className = "" }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setVisible(true), delay);
                    io.disconnect();
                }
            },
            { threshold: 0.12, rootMargin: "0px 0px -80px 0px" }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [delay]);

    return (
        <Tag ref={ref} className={`reveal ${visible ? "is-visible" : ""} ${className}`}>
            {children}
        </Tag>
    );
}
